import { Toast } from "vant";

/**
 * @description: 填报范围逻辑处理函数
 * @param {list 列表数据}
 *
  import validRange from "@/utils/validRange.js";
  try {
        validRange(list);
      } catch (error) {
        return false;
      }
 */
export default function validRange(list) {
  let messageText = "";
  list.forEach(item => {
    const {
      goods_minimum,
      goods_maximum,
      ThisPrice,
      isGoods,
      VarietyName,
      StandardName,
      TargetName
    } = item;
    if (
      !isGoods &&
      ThisPrice &&
      item.dataType !== '1003' &&
      ThisPrice !== "" &&
      (goods_minimum || goods_maximum)
    ) {
      const price = Number(ThisPrice);
      const min = goods_minimum ? Number(goods_minimum) : null;
      const max = goods_maximum ? Number(goods_maximum) : null; // 商品最小值和最大值

      if (min != null && price < min && max == null) {
        messageText = `本期只能填报大于【${min}】`;
      } else if (max != null && price > max && min == null) {
        messageText = `本期只能填报小于【${max}】`;
      } else if ((min != null && price < min) || (max != null && price > max)) {
        messageText = `本期只能填报【${min}】到【${max}】之间`;
      }
      if (messageText) {
        Toast.fail(`${item.VarietyName}--${item.StandardName}--${item.TargetName}，${messageText}`);
        throw new Error();
      }
    }
  });
}
